export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";